import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './providerBanner.module.css';

export const ProviderBanner = ({ btnText, link }) => {
  return (
    <div className={styles.providerBanner}>
      <Link className={styles.link} to={link}>
        {btnText}
      </Link>
    </div>
  );
};

ProviderBanner.propTypes = {
  btnText: PropTypes.string,
  link: PropTypes.string,
};
